import React, { FunctionComponent } from 'react'
import { useLocation } from 'react-router'

import useDispatch from 'hooks/useDispatch'
import useIsServerSide from '../../hooks/useIsServerSideContext'
import useLoginModalState from '../../hooks/useLoginModalState'
import { openSelectEscape } from './reduxSlice'
import { setActionToReplay } from '../../actions/authActions'

import { makeItemKey } from '../../dashboard/MyBucketlists/gql/getBucketListItemsIndexHelpers'

interface WithSelectEscapeProps {
  itemId: string
  itemType: GQL_Searchable
  bookingAdventuresIndex?: GQL_BookingAdventuresIndex
  bucketListItemsIndex: GQL_BucketListItemsIndex
  analyticsSource?: string
}

const WithSelectEscape: FunctionComponent<WithSelectEscapeProps> = ({
  itemId,
  itemType,
  bookingAdventuresIndex,
  bucketListItemsIndex,
  children,
  analyticsSource,
}) => {
  const dispatch = useDispatch()
  const { currentUserSignedIn, openLoginModal } = useLoginModalState()
  const isServer = useIsServerSide()
  const { pathname } = useLocation()

  const handleSelectEscapeOpen = () => {
    const openSelectEscapeAction = openSelectEscape({
      itemId,
      itemType,
      source: analyticsSource || pathname,
    })

    if (!currentUserSignedIn) {
      openLoginModal()
      dispatch(setActionToReplay(openSelectEscapeAction))
    } else {
      dispatch(openSelectEscapeAction)
    }
  }

  const itemKey = makeItemKey({ itemId, itemType })
  const bucketListIds = bucketListItemsIndex
    ? bucketListItemsIndex[itemKey]
    : []

  const bookingIds =
    itemType === 'Adventure' &&
    bookingAdventuresIndex &&
    bookingAdventuresIndex[itemId]

  if (isServer) {
    return <>{children}</>
  }

  return (
    <>
      {React.Children.map(children, (child) => {
        const additionalProps = {
          isInEscape: bucketListIds?.length > 0 || bookingIds?.length > 0,
          onSelectEscapeClick: handleSelectEscapeOpen,
        }
        if (React.isValidElement(child)) {
          return React.cloneElement(child, additionalProps)
        }
        return child
      })}
    </>
  )
}

export default WithSelectEscape
